import { apiService } from "./apiService";
import apiRoutes from "./apiRoutes";

export const getAllCommunityQuestions = async (filter="",productId,page = 1, limit = 10) => {
  try {
    const res = await apiService.get(
      `${apiRoutes.getAllCommunityQuestions}?filter=${filter}&productId=${productId}&page=${page}&limit=${limit}`
    );
    return res.data;
  } catch (err) {
    console.error("Error fetching community questions:", err);
    return { success: false, message: err.message };
  }
};

export const getMyCommunityAnswers = async (filter="",productId,page = 1, limit = 10) => {
  try {
    const res = await apiService.get(
      `${apiRoutes.getMyCommunityAnswers}?filter=${filter}&productId=${productId}&page=${page}&limit=${limit}`
    );
    return res.data;
  } catch (err) {
    console.error("Error fetching my community answers:", err);
    return { success: false, message: err.message };
  }
};

export const submitCommunityAnswer = async (payload) => {
  try {
    const res = await apiService.post(apiRoutes.submitCommunityAnswer, payload);
    return res.data;
  } catch (err) {
    console.error("Error submitting answer:", err);
    return { success: false, message: err.message };
  }
};

export const createCommunityQuestion = async (payload) => {
  try {
    const res = await apiService.post(apiRoutes.createCommunityQuestion, payload);
    return res.data;
  } catch (err) {
    console.error("Error creating question:", err);
    return { success: false, message: err.message };
  }
};


export const updateCommunityAnswer = async (payload) => {
    const response = await apiService.post(apiRoutes.updateCommunityAnswer, payload);
    return response.data;
  };
  
  export const deleteCommunityAnswer = async (id) => {
    const response = await apiService.get(`${apiRoutes.removeCommunityAnswer}?id=${id}`);
    return response.data;
  };

  export const deleteCommunityQuestion = async (id) => {
    const response = await apiService.get(`${apiRoutes.removeCommunityQuestion}?id=${id}`);
    return response.data;
  };